import {
  VISUALITZACIO_OMPLIR_ID_ESPECIE,
  VISUALITZACIO_OBTENIR_DADES,
  VISUALITZACIO_OBTENIR_OBSERVACIONS,
  VISUALITZACIO_OMPLIR_ID_FENOFASE,
  VISUALITZACIO_OMPLIR_DATA_INICI,
  VISUALITZACIO_OMPLIR_DATA_FI,
  VISUALITZACIO_OMPLIR_DATA_SELECCIONADA,
  VISUALITZACIO_SELECCIO_TIPUS,
  VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA,
  SWITCH_MENU_VISIALITZAR_OBSERVACIONS
} from "./actionTypes";
import {
  fetchDadesVisualitzar,
  fetchObservacionsVisualitzar
} from "./consultesServidor";

export const obtenirDadesVisualitzacio = () => {
  return dispatch => {
    return dispatch({
      type: VISUALITZACIO_OBTENIR_DADES,
      promise: fetchDadesVisualitzar()
    });
  };
};

export const omplirIdEspecieVisualitzacio = idEspecie => ({
  type: VISUALITZACIO_OMPLIR_ID_ESPECIE,
  payload: idEspecie
});

export const omplirIdFenofaseVisualitzacio = idFenofase => ({
  type: VISUALITZACIO_OMPLIR_ID_FENOFASE,
  payload: idFenofase
});

export const omplirDataIniciVisualitzacio = dataInici => ({
  type: VISUALITZACIO_OMPLIR_DATA_INICI,
  payload: dataInici
});

export const omplirDataFiVisualitzacio = dataFi => ({
  type: VISUALITZACIO_OMPLIR_DATA_FI,
  payload: dataFi
});

export const omplirDataSeleccionadaVisualitzacio = dataSeleccionada => ({
  type: VISUALITZACIO_OMPLIR_DATA_SELECCIONADA,
  payload: dataSeleccionada
});

export const omplirEspecieFenofaseSeleccionadaVisualitzacio = (
  idEspecie,
  idFenofase
) => ({
  type: VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA,
  payload: { idEspecie: idEspecie, idFenofase: idFenofase }
});

export const selecioTipusVisualitzacio = tipus => ({
  type: VISUALITZACIO_SELECCIO_TIPUS,
  payload: tipus
});

export const obtenirObservacionsVisualitzacio = (
  dataInici,
  dataFi,
  idEspecie,
  idFenofase
) => {
  return dispatch => {
    return dispatch({
      type: VISUALITZACIO_OBTENIR_OBSERVACIONS,
      promise: fetchObservacionsVisualitzar(
        dataInici,
        dataFi,
        idEspecie,
        idFenofase
      )
    });
  };
};

export const switchVisibilitatMenu = () => {
  return {
    type: SWITCH_MENU_VISIALITZAR_OBSERVACIONS
  };
};
